<template>
  <div class="download-app-container" style="margin: 2px">
    <!--  -->
    <div class="download-app-content">
      <div class="head_container">
        <div class="icon_text_container">
          <img class="icon" src="../assets/heals_logo.png" alt />
          <div>heals</div>
        </div>
      </div>
      <div class="download_button_container">
        <a href="https://play.google.com/store/apps/details?id=com.healshealthcare.patientapp">
          <img src="../assets/download_andrid.png" alt />
        </a>
        <a href="https://apps.apple.com/hk/app/heals-patient-app/id1442752092">
          <img src="../assets/download_ios.png" alt />
        </a>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "download-healsapp",

    data() {
      return {};
    },

    mounted() {
      this.downApp()
    },
    methods: {
      downApp() {
        let ua = navigator.userAgent.toLowerCase();
        //Android终端
        let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1; //iOS终端
        let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          //iOS终端
          window.location = "https://apps.apple.com/hk/app/heals-patient-app/id1442752092"
        } else if (/(Android)/i.test(navigator.userAgent)) {
          //Android终端
          window.location = "https://play.google.com/store/apps/details?id=com.healshealthcare.patientapp";
        }
      },

      isWeixinBrowser() {
        return /micromessenger/.test(ua) ? true : false;
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import "../../style/download-app.css";
</style>


// WEBPACK FOOTER //
// src/components/download-app.vue